// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#jewelleryViewerControls{text-align:center!important;margin-top:1rem;padding-bottom:0!important}@media(max-width:991px){#jewelleryViewerControls{padding-bottom:1.5rem}}@media(min-width:992px){#jewelleryViewerControls{margin-top:1rem}}.vm-images #jewelleryViewerControls{display:none;margin-top:0}@media(max-width:991px){#handAnalyzingProgress{top:20rem!important;left:50%!important}}", ""]);
// Exports
module.exports = exports;
